import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../../../environments/environment.prod';
import {HeaderService} from '../../../../../services/header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TvaSummary} from '../../../../../models/TvaSummary';

@Component({
  selector: 'app-approve-fac-f',
  templateUrl: './approve-fac-f.component.html',
  styleUrls: ['./approve-fac-f.component.scss']
})
export class ApproveFacFComponent implements OnInit {

    mode: 'validation' | 'apercu' = 'validation';

    file: string = environment.file_url;
    constructor(private headerService: HeaderService, private router : Router, private route: ActivatedRoute) { }
    tvaSummary: TvaSummary[] = [];
    totals = {
        totalHT: 0,
        totalTVA: 0,
        totalTTC: 0,
        timbreFiscal: 0.6,
        netAPayer: 0.6
    };
    ngOnInit(): void {
        this.mode = this.route.snapshot.paramMap.get('mode') as 'validation' | 'apercu';
        this.setHeaderConfig();

    }
    setHeaderConfig(): void {
        if (this.mode === 'validation') {
            this.headerService.setConfig({
                title: 'Facture fournisseurs',
                buttons: [
                    { label: 'Retour', action: () => this.retour(), type: 'primary' },
                    { label: 'Annuler', action: () => this.retour(), type: 'secondary' },
                    { label: 'Valider', action: () => this.retour(), type: 'primary' },

                ]
            });
        } else {
            this.headerService.setConfig({
                title: ' Facture fournisseurs',
                buttons: [
                    { label: 'Mettre à jour', action: () => this.editagain(), type: 'primary' }
                ]
            });
        }
    }
    exportData() {
    }

    retour() {
        this.router.navigate(['/achat/facture-fournisseur']);
    }
    editagain(){
        this.router.navigate(['/achat/facture-fournisseur/add-facture-fournisseur']);
    }

}
